/**
 * Deterministic department -> colour mapping, shared by every place the org
 * chart shows a department: `OrgNode`'s card (avatar + pill), the branch
 * group labels above each fan-out in `OrgChartTree`, and the mini chart's
 * group captions in `OrgChartExport`. One palette, one mapping, imported
 * everywhere rather than re-declared - the whole point is that the same
 * department always gets the same colour, wherever it is drawn.
 *
 * Indexed by `department_id` modulo the palette length so no server-side
 * colour mapping is needed. Plain Tailwind palette colours (not the
 * extended primary/success/warning/danger tokens) so five-plus departments
 * stay visually distinct.
 */
const DEPARTMENT_COLORS = [
  { avatar: 'bg-slate-600', pill: 'bg-slate-100 text-slate-700' },
  { avatar: 'bg-indigo-600', pill: 'bg-indigo-100 text-indigo-700' },
  { avatar: 'bg-pink-600', pill: 'bg-pink-100 text-pink-700' },
  { avatar: 'bg-emerald-600', pill: 'bg-emerald-100 text-emerald-700' },
  { avatar: 'bg-orange-600', pill: 'bg-orange-100 text-orange-700' },
  { avatar: 'bg-cyan-600', pill: 'bg-cyan-100 text-cyan-700' },
];

export const colorsForDepartment = (departmentId) => {
  const len = DEPARTMENT_COLORS.length;
  const idx = ((Number(departmentId) || 0) % len + len) % len;
  return DEPARTMENT_COLORS[idx];
};

export default DEPARTMENT_COLORS;
